@if (toastService.toast(); as currentToast) {
  <div class="sa-toast-stack">
    <div
      class="sa-toast"
      (mouseenter)="pauseTimer()"
      (mouseleave)="resumeTimer()"
    >
      <div class="sa-toast-body">
        <div
          class="sa-toast-icon"
          [class.success]="currentToast.type === 'success'"
          [class.warning]="currentToast.type === 'warning'"
          [class.danger]="currentToast.type === 'danger'"
        >
          @switch (currentToast.type) {
            @case ('success') {
              <i class="fa-solid fa-circle-check" aria-hidden="true"></i>
            }
            @case ('warning') {
              <i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
            }
            @case ('danger') {
              <i class="fa-solid fa-circle-xmark" aria-hidden="true"></i>
            }
          }
        </div>

        <p class="sa-toast-message">{{ currentToast.text }}</p>

        <button
          type="button"
          class="sa-toast-close"
          aria-label="Close notification"
          (click)="dismiss()"
        >
          <i class="fa-solid fa-xmark" aria-hidden="true"></i>
        </button>
      </div>

      @if (!timerStopped()) {
        <div class="sa-toast-footer">
          <span>
            This message will close in
            <strong>{{ remainingTime() }}</strong>
            second{{ remainingTime() === 1 ? '' : 's' }}.
          </span>
          <button type="button" (click)="stopTimer()">Click to stop</button>
        </div>

        <div
          class="sa-toast-progress"
          [class.success]="currentToast.type === 'success'"
          [class.warning]="currentToast.type === 'warning'"
          [class.danger]="currentToast.type === 'danger'"
          [class.paused]="timerPaused()"
          [style.animation-duration.ms]="currentToast.duration"
        ></div>
      }
    </div>
  </div>
}
